export const brandKBB: string = 'kbb';
export const brandATC: string = 'atc';
/* */
export const getBrand = () => {
  const hostname:string = globalThis.location?.hostname?.toLowerCase();
  if (hostname.includes('kbb')) {
    return brandKBB;
  } else {
    // URLSearchParams API is supported by all modern browsers
    const searchParams = new URLSearchParams(globalThis.location?.search);
    if(searchParams.get('brand')?.toLowerCase() === brandKBB ) {
      return brandKBB;
    }
  }
  return brandATC;
};
export const cleanBrandParam = (param) => {
  return param.toLowerCase().startsWith('kb') ? brandKBB : brandATC;
}
export const isKBB = () => getBrand() === brandKBB;
export const isATC = () => getBrand() === brandATC;
export default getBrand;
